import { useEffect } from 'react';
import { string } from 'prop-types';

var createElement = function createElement(url) {
  var element = document.createElement('link');
  element.rel = 'stylesheet';
  element.href = url;
  return element;
};

var ReactFontLoader = function ReactFontLoader(_ref) {
  var url = _ref.url;
  useEffect(function () {
    var element = createElement(url);
    document.head.appendChild(element);
    return function () {
      return document.head.removeChild(element);
    };
  }, []);
  return null;
};

ReactFontLoader.propTypes = {
  url: string.isRequired
};

export default ReactFontLoader;
//# sourceMappingURL=index.modern.js.map
